export default {
  templates(state) {
    return state.templates;
  },
};
